import React, { useState } from 'react';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';

// styles
import './chartTitleIntro.scss';

interface ChartTitleIntroProps {
  number: number;
  title: string;
  children: React.ReactNode;
}

const ChartTitleIntro = (props: ChartTitleIntroProps) => {
  return (
    <div className="chartTitleIntro">
      <div className="chartTitleIntro-titlenumber">
        <div className="chartTitleIntro-number">
          <h2>{props.number}.&nbsp;</h2>
        </div>
        <div className="chartTitleIntro-title">
          <h2>{props.title}</h2>
        </div>
      </div>
      <div className="chartTitleIntro-intro">{props.children}</div>
      <div className="d-none d-md-inline-block">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default ChartTitleIntro;
